<template>
  <div>
    <small class="caption">
      <strong>{{
        beneficiarioPinss ? beneficiarioPinss.operadoraNomeFantasia : ""
      }}</strong
      ><br />
      Registro da Operadora na ANS:
      {{ beneficiarioPinss ? beneficiarioPinss.unimedRegistroAns : "" }}<br />
      Razão Social:
      {{ beneficiarioPinss ? beneficiarioPinss.operadoraRazaoSocial : ""
      }}<br />
    </small>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
